exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navigation-notice[data-v-102b8074] {\n  margin-left: auto;\n}", ""]);

// exports
